/**
 * Main Entry Point
 * Code Board — Vue 3 Application
 */

import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { i18n } from './plugins/i18n'
import { useAppEventsStore } from '@/stores/app-events'
import { api } from '@/core/api'
import { logger } from '@/utils/logger'
import { vTooltip } from '@/directives/tooltip'
import './styles/main.css'

// Global error handlers
window.onerror = (message, source, _lineno, _colno, error) => {
  logger.error('Global', 'Uncaught error', { message, source, error })
  if (message === 'Script error.' || !source) return false
  return false
}

window.addEventListener('unhandledrejection', (event) => {
  logger.error('Global', 'Unhandled rejection', {
    message: event.reason?.message || event.reason?.toString() || 'Unknown rejection',
    stack: event.reason?.stack,
  })
})

// Handle token from URL query (legacy compat: direct token login)
const urlParams = new URLSearchParams(window.location.search)
const token = urlParams.get('token')
if (token) {
  api.setToken(token)
  // Clean the URL
  window.history.replaceState({}, '', window.location.pathname)
}

// Create Vue app
const app = createApp(App)

// Install plugins (order matters — same as legacy init)
const pinia = createPinia()
app.use(pinia)
app.use(i18n)
app.use(router)

// Register global directives
app.directive('tooltip', vTooltip)

// Vue global error handler
app.config.errorHandler = (err, _instance, info) => {
  logger.error('Vue', 'Component error', err, info)
}

// Watch for UNAUTHORIZED events from api layer → redirect to landing
const appEvents = useAppEventsStore()
watch(() => appEvents.unauthorizedAt, (val) => {
  if (val > 0) router.push('/')
})

// Mount
app.mount('#app')
